import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tag } from 'primereact/tag';

const PriceListPage = ({ hookData }) => {
    const {
        toast,
        activeTab,
        setActiveTab,
        filters,
        selectedPartCode,
        priceList,
        totalRecords,
        priceHistoryList,
        priceHistoryTotalRecords,
        isLoadingPrices,
        isLoadingHistory,
        handleHistoryClick,
        formatCurrency,
        formatDate,
        first,
        onPageChange,
        onSort,
        sortField,
        sortOrder,
        th
    } = hookData;

    const historyButtonTemplate = (rowData) => <Button icon="pi pi-history" className="p-button-rounded p-button-text p-button-sm" onClick={() => handleHistoryClick(rowData.partCode)} tooltip={th('dealerPartsCatalog.priceList.table.viewHistory')} />;

    // Stok durumu badge'i
    const stockStatusTag = (status) => (
        <Tag
            value={status ? th('product.stockAvailable') : th('product.stockUnavailable')}
            severity={status ? 'success' : 'danger'}
        />
    );

    // isShowStockStatus kontrolü - ilk item'dan al
    const showStockStatus = priceList && priceList.length > 0 && priceList[0].isShowStockStatus === true;

    return (
        <div>
            <Toast ref={toast} />
            <div className="flex justify-content-between align-items-center mb-4">
                <h2 className="m-0">{th('dealerPartsCatalog.priceList.pageTitle')}</h2>
            </div>

            <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                <TabPanel header={th('dealerPartsCatalog.priceList.tabs.priceList')}>
                    <DataTable
                        value={priceList}
                        loading={isLoadingPrices}
                        emptyMessage={th('dealerPartsCatalog.priceList.messages.noRecords')}
                        paginator
                        rows={filters.pageSize}
                        rowsPerPageOptions={[10, 20, 50]}
                        totalRecords={totalRecords}
                        lazy
                        first={first}
                        onPage={onPageChange}
                        onSort={onSort}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        stripedRows
                        showGridlines
                    >
                        <Column header={th('dealerPartsCatalog.priceList.table.history')} body={historyButtonTemplate} />
                        <Column field="partCode" header={th('dealerPartsCatalog.priceList.table.partCode')} sortable />
                        <Column field="partName" header={th('dealerPartsCatalog.priceList.table.partName')} sortable />
                        <Column field="brand" header={th('dealerPartsCatalog.priceList.table.brand')} sortable />
                        <Column field="meins" header={th('dealerPartsCatalog.priceList.table.uom')} sortable />
                        <Column field="retailPrice" header={th('dealerPartsCatalog.priceList.table.retailPrice')} body={(rowData) => formatCurrency(rowData.retailPrice, rowData.currency)} sortable />
                        <Column field="discountedPrice" header={th('dealerPartsCatalog.priceList.table.discountedPrice')} body={(rowData) => formatCurrency(rowData.discountedPrice, rowData.currency)} sortable />
                        <Column field="discountRate" header={th('dealerPartsCatalog.priceList.table.discountRate')} body={(rowData) => rowData.discountRate ? `${rowData.discountRate}%` : '-'} sortable />
                        {showStockStatus && (
                            <Column field="bursaStockStatus" header={th('dealerPartsCatalog.priceList.table.bursaStock')} body={(rowData) => stockStatusTag(rowData.bursaStockStatus)} sortable />
                        )}
                        {showStockStatus && (
                            <Column field="germanyStockStatus" header={th('dealerPartsCatalog.priceList.table.germanyStock')} body={(rowData) => stockStatusTag(rowData.germanyStockStatus)} sortable />
                        )}
                    </DataTable>
                </TabPanel>
                <TabPanel header={th('dealerPartsCatalog.priceList.tabs.priceHistory')}>
                    {selectedPartCode && (
                        <div className="mb-3">
                            <p>{th('dealerPartsCatalog.priceList.messages.viewingHistoryFor').replace('{partCode}', selectedPartCode)}</p>
                        </div>
                    )}
                    <DataTable
                        value={priceHistoryList}
                        loading={isLoadingHistory}
                        emptyMessage={selectedPartCode ? th('dealerPartsCatalog.priceList.messages.noHistory') : th('dealerPartsCatalog.priceList.messages.selectPartForHistory')}
                        paginator
                        rows={10}
                        stripedRows
                        showGridlines
                    >
                        <Column field="itemCode" header={th('dealerPartsCatalog.priceList.table.partCode')} />
                        <Column field="netAmount" header={th('dealerPartsCatalog.priceList.table.price')} body={(rowData) => formatCurrency(rowData.netAmount)} />
                        <Column field="createdDate" header={th('dealerPartsCatalog.priceList.table.date')} body={(rowData) => formatDate(rowData.createdDate)} />
                    </DataTable>
                </TabPanel>
            </TabView>
        </div>
    );
};

export default PriceListPage;
